import React, {useEffect} from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';
import {
  FloorBidderBadgeValidation,
  DecisionButtonText, ConfirmModal,
} from 'components/project/ClerkScreen';
import { DecisionButton, HotKeyLabel } from '../Styles';
import {EndLaneButton} from "../../EndLane/Styles";

const SoldButton = observer(() => {
  const {
    BidStore: {
      auction,
      showSoldButton,
      shouldDisableDecisionButtons,
      laneSuspended,
      auctionProduct,
      setProperty
    },
    UIStore: {
      handleDecisionClick,
      handleRejectFBBValidation,
      handleProceedFBBValidation,
      getHotKey,
    },
    MessageStore: {
      sellerAction,
    },
  } = useStores();

  const { currentBid } = auction;
  const {reserveNotMetAlertThreshold} = auctionProduct || {};
  const key = auction.firstDecisionClick;
  const buttonText = 'Sold';
  const buttonWasFirstClicked = key === buttonText && laneSuspended;

  if (!sellerAction?.sellerAction && buttonWasFirstClicked && reserveNotMetAlertThreshold && currentBid < reserveNotMetAlertThreshold) {
    return (<>
      <ConfirmModal
          title="Sale price is less than reserve."
          message="Are you sure want to continue?"
          confirmText="Confirm"
          onConfirm={() => handleDecisionClick(buttonText)}
          renderLink={(modal) => {
            setProperty('confirmModal', modal);
            return (
                showSoldButton ? (
                    <DecisionButton
                        isFirstClick={buttonWasFirstClicked}
                        invalid={false}
                        disabled={shouldDisableDecisionButtons}
                        onClick={() => modal.open()}
                        tabIndex={6}
                        color="#FFFFFF"
                        bgColor="#009E0F"
                        firstClick={buttonWasFirstClicked}
                        bgVariance={20}
                        data-testid="sold-btn"
                    >
                      <DecisionButtonText confirming={laneSuspended} text={buttonText} />
                      <HotKeyLabel color="white">
                        {getHotKey('target', 'SOLD').label}
                      </HotKeyLabel>
                    </DecisionButton>
                ) : (
                    <FloorBidderBadgeValidation
                        decisionText={`${buttonText} tom`}
                        handleReject={handleRejectFBBValidation}
                        handleProceed={handleProceedFBBValidation(buttonText)}
                    />
                )
            )
          }}
      />
    </>)
  }


  return (
    <>
      {showSoldButton ? (
        <DecisionButton
          isFirstClick={buttonWasFirstClicked}
          invalid={false}
          disabled={shouldDisableDecisionButtons}
          onClick={() => handleDecisionClick(buttonText)}
          tabIndex={6}
          color="#FFFFFF"
          bgColor="#009E0F"
          firstClick={buttonWasFirstClicked}
          bgVariance={20}
          data-testid="sold-btn"
        >
          <DecisionButtonText confirming={laneSuspended} text={buttonText} />
          <HotKeyLabel color="white">
            {getHotKey('target', 'SOLD').label}
          </HotKeyLabel>
        </DecisionButton>
      ) : (
        <FloorBidderBadgeValidation
          decisionText={buttonText}
          handleReject={handleRejectFBBValidation}
          handleProceed={handleProceedFBBValidation(buttonText)}
        />
      )}
    </>
  );
});

export default SoldButton;
